export const log = ( /* ...args */ ) => {
	// eslint-disable-next-line no-undef
	if ( process.env.NODE_ENV !== 'production' ) {
		// console.log( ...args );
	}
};

export const logError = ( ...args ) => {
	// eslint-disable-next-line no-undef
	if ( process.env.NODE_ENV !== 'production' ) {
		console.error( ...args );
	}
};
